import type { AnyNode, ArrayForm, AtomForm, ChoiceForm, EnumForm, ObjectForm } from "@pdfking/forms"
import { CreateMixin } from "@pdfking/reactivity/preact"

export type AnyChoice = ChoiceForm<unknown> | ChoiceForm<unknown[]>

export const FormMixin = CreateMixin({
  props: { node: undefined as AnyNode | undefined },
})

export const AtomFormMixin = CreateMixin({
  props: { node: undefined as AtomForm<unknown> | undefined },
})

export const ChoiceFormMixin = CreateMixin({
  props: { node: undefined as AnyChoice | undefined },
})

export const ObjectMixin = CreateMixin({
  props: { node: undefined as ObjectForm<Record<string, unknown>> | undefined },
})

export const ArrayMixin = CreateMixin({
  props: { node: undefined as ArrayForm<unknown> | undefined },
})

export const EnumMixin = CreateMixin({
  props: { node: undefined as EnumForm<{ enum: string }> | undefined },
})
